<template>
      <div class="row" style="height: 100%;">
        <div class="pl-5 pr-5" style="width: 100%;height: 100%;">
          <div class="row mt-3">
            <div class="col-12">
              <h5 style="font-weight: 700; text-transform: uppercase">
                {{ speciality.name }}
              </h5>
            </div>
          </div>

          <div class="row">
            <div class="col-lg-8 offset-lg-2 pl-5 pr-5">
              <cool-select class="custom-input" placeholder="Find your doctor" :items="[]" v-model="selectedDoctor" @search="searchDoctor">
                <template #no-data>
                  {{""}}
                </template>
              </cool-select>
            </div>
          </div>
          <div name="el-zoom-in-center" appear tag="div" class="row doctor-list" style="padding-top: 10px;">
            <div class="col-lg-4 pb-4" v-for="doctor in searchedDoctors" :key="doctor._id">
              <doctor-card :doctor="doctor"></doctor-card>
            </div>
            <infinite-loading spinner="waveDots" @infinite="getDoctorDetails" forceUseInfiniteWrapper="window">
              <span slot="no-more">{{ $t("message.No more doctors") }}</span>
              <span slot="no-results"></span>
            </infinite-loading>
          </div>
          <div class="col-12 pb-5 text-center" v-if="!GETTING_DOCTORS && doctors.length < 1">
            <div class="row">
              <div class="col-12">
                <i style="color: #fff; font-size: large">{{
                  $t("message.No doctors available for this speciality")
                }}</i>
              </div>
              <div class="col-12">
                <img src="@/assets/img/doctor-patient.svg" style="height: 10em; margin-top: 20em" />
              </div>
            </div>
          </div>
        </div>
      </div>
</template>
<style>
  .infinite-status-prompt{
    padding: 20px;
    width: calc(100vw - 3em);
  }
</style>

<script>
import { CoolSelect } from "vue-cool-select";

export default {
  name: "speciality",

  components: {
    CoolSelect,
  },

  data() {
    return {
      doctors: [],
      searchedDoctors: [],
      selectedDoctor: null,
      GETTING_DOCTORS: true,
      inpersonOnly: false,
      telemedOnly: false,
      searchedDoctorsPagination: {
        pageNumber: 1,
        totalPages: 0,
      }
    };
  },

  computed: {
    speciality() {
      return this.$store.state.selectedSpeciality;
    },
    settings() {
      return this.$store.state.settings;
    },
    baseUrl() {
      return this.$store.state.baseUrl;
    },
  },

  async mounted() {
    /*   let urlParams = new URLSearchParams(window.location.search);
    this.inpersonOnly = urlParams.get("inperson_only");
    this.telemedOnly = urlParams.get("telemed_only");
 */
    if (this.$route.params.specialityId) {
      let speciality = await this.$store.dispatch(
        "getSpecialityWithTenant",
        this.$route.params.specialityId
      );
      console.log(speciality);

      this.$store.commit("setState", {
        stateName: "selectedSpeciality",
        stateValue: speciality,
      });

      //If tenant is not in the store, for speciality link based booking
      if (!this.tenant && speciality.tenant && speciality.tenant.name) {
        this.$store.commit("setState", {
          stateName: "tenant",
          stateValue: speciality.tenant.name,
        });
      }
      this.getDoctorDetails();
    }

  /*   let settings = await this.$store.dispatch("getPublicSettings");

    if (settings) {
      this.$store.commit("setState", {
        stateName: "settings",
        stateValue: settings,
      });
    } */
  },

  methods: {
    searchDoctor(query) {
      this.searchedDoctors = [];

      if (query) {
        query = query.toLowerCase();
        this.searchedDoctors = this.doctors.filter((doc) => {
          return (
            (doc.firstName &&
              doc.firstName.toLowerCase().indexOf(query) > -1) ||
            (doc.middleName &&
              doc.middleName.toLowerCase().indexOf(query) > -1) ||
            (doc.lastName && doc.lastName.toLowerCase().indexOf(query) > -1)
          );
        });
      } else {
        this.searchedDoctors = this.doctors;
      }
    },
    async getDoctorDetails($state) {
      try{
        let response = await this.$store.dispatch(
        "getTelemedDoctorsBySpeciality",
        {
          pageNumber: this.searchedDoctorsPagination.pageNumber,
          selectedSpecialityId: this.$route.params.specialityId,
          pageSize : 5
        }
      );
      this.GETTING_DOCTORS = false;
      if (response.data && response.data.length) {
          this.searchedDoctors.push(...response.data);
          this.searchedDoctorsPagination.totalPages = response.totalPages;
          this.searchedDoctorsPagination.pageNumber += 1;
          this.doctors = this.searchedDoctors;
          $state && $state.loaded();
        } else {
          $state && $state.complete();
        }
      }catch(error){
        console.log(error);
      }
    },
  },
};
</script>
